import FundProperties from "./FundProperties"

export default FundProperties
